/**
 * Every word on the co-op lobby: the room, the code panel, the roster and the reconnect line.
 *
 * Chrome throughout. Nobody is in the fiction yet, and half of these sentences are instructions for
 * getting four people into one room, which is the one job voice would make harder. See
 * [src/text/AGENTS.md](./AGENTS.md).
 *
 * Five files render this screen and three of them render the words "Stop waiting" or "Ready". They
 * agree here or they drift apart there.
 *
 * The wording for what a peer just did lives in `@/net/lobby/lobbyNotices`, beside the state that
 * raises it, and the wording for a failure lives in `@/net/session/sessionErrors`, for the same
 * reason.
 */

export const LOBBY_TITLE = 'Play together';
/** The one instruction the room needs. The panel below says the code; this says who types it. */
export const LOBBY_STRAP = 'Share the code. Others enter it on the menu.';

/** Before any transport exists. Replaced by the catalogue's wording the moment one does. */
export const LOBBY_DISCONNECTED = 'Not connected.';

export const LOBBY_RULES_LABEL = 'Friendly fire';
export const LOBBY_RULES_ON = 'On';
export const LOBBY_RULES_OFF = 'Off';

export const LOBBY_READY = 'Ready';
export const LOBBY_NOT_READY = 'Not ready';
export const LOBBY_START = 'Start';
export const LOBBY_BACK = 'Back to menu';

/**
 * The host pressed Start with somebody not ready. Said once, then the second press goes anyway, so
 * the sentence has to carry both halves: who is holding it, and what pressing again will do.
 */
export function lobbyNotReadyWarning(count: number): string {
  const who = count === 1 ? 'One player is not ready.' : `${String(count)} players are not ready.`;
  return `${who} Press Start again to go anyway.`;
}

export const LOBBY_CODE_LABEL = 'Join code';
export const LOBBY_CODE_COPY = 'Copy';
export const LOBBY_CODE_COPIED = 'Copied';
/** The clipboard refused. Named rather than silent, because the code still has to be read out. */
export const LOBBY_CODE_COPY_FAILED = 'Copy failed';

export const LOBBY_TAG_HOST = 'Host';
export const LOBBY_TAG_SELF = 'You';
export const LOBBY_TAG_HELD = 'Reconnecting';

/** On both the lobby panel and the in-game overlay, which are the same wait seen twice. */
export const LOBBY_STOP_WAITING = 'Stop waiting';
